import React, { FC, useState } from "react";
import Modal from "./Modal";
import { Button } from "../../Components/Base";
import { TransactionPostCoachGallery } from "../../Services/Transactions";
import { Toast } from "../../Utils";

interface IProps {
  onClose: () => void;
  onSubmit: () => void;
}

const CreateCoachAssetsModal: FC<IProps> = ({ onClose, onSubmit }) => {
  const [image, setImage] = useState<File | null>(null);
  const [isLoading, setIsLoading] = useState<boolean>(false);

  // ================================================================================================================

  const handleSubmit = () => {
    if (image) {
      setIsLoading(true);
      const form = new FormData();
      form.append("image", image);
      TransactionPostCoachGallery(form)
        .then(({ data: res }) => {
          if (res.transaction_status) {
            setImage(null);
            Toast("success", res.message);
            onClose();
            onSubmit();
          } else {
            Toast("error", res.message);
          }
        })
        .finally(() => setIsLoading(false));
    }
  };

  // ================================================================================================================

  return (
    <Modal close={onClose}>
      <div
        style={{ width: 520 }}
        className="p-3 z-3 bg-white flex flex-column justify-content-center align-items-center rounded-2 shadow"
      >
        <div className="mb-2 pb-3 pt-1 border-bottom d-flex justify-content-start  align-items-center gap-2">
          <i className="bi bi-plus-circle-fill text-primary fs-5 d-flex" />
          <p className="fw-bold m-0">افزودن عکس</p>
        </div>
        <div className="d-flex flex-column align-items-center justify-content-center gap-2 py-2">
          <div className="w-100 h-100 pb-0 p-3 overflow-hidden rounded-t-3 d-flex justify-content-center align-items-center">
            <input
              id="screenshot_input"
              type="file"
              hidden
              accept=".png,.jpg,.jpeg"
              onChange={(e) =>
                setImage(e.target.files ? e.target.files[0] : null)
              }
            />
            <label
              htmlFor="screenshot_input"
              className="bg-white cursor-pointer border border-info rounded-3 d-flex justify-content-center gap-3 flex-column align-items-center w-100"
              style={{height: 200}}
            >
              {image ? (
                <img
                  src={URL.createObjectURL(image)}
                  alt={image.name}
                  className="w-100 h-100 object-fit-contain rounded-3"
                />
              ) : (
                <>
                  <i
                    className="fa fa-cloud-upload-alt text-primary"
                    style={{ fontSize: 60 }}
                  />
                  <h4>برای آپلود عکس کلیک کنید.</h4>
                </>
              )}
            </label>
          </div>
        </div>
        <hr />
        <div className="d-flex justify-content-end gap-2 w-100 align-items-center">
          <Button
            btnClass="text-danger border border-danger w-25 mb-0"
            text="انصراف"
            onClick={onClose}
          />
          <Button
            btnClass="bg-primary text-white w-25 mb-0"
            text="ثبت"
            isLoading={isLoading}
            disabled={!image}
            onClick={handleSubmit}
          />
        </div>
      </div>
    </Modal>
  );
};

export default CreateCoachAssetsModal;
